import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";

export const useManifestDetails = (manifestNumber?: string | null) => {
  const { data, isLoading, isFetching, error } = useQuery<any>({
    queryKey: [QUERY_KEYS.MANIFEST_DETAILS, manifestNumber],
    queryFn: async () => {
      const response = await apiQueryAdapter.query<any>(
        `/linehaul-manifests/manifest-details/${manifestNumber}`,
        "GET"
      );
      return response.data;
    },
    enabled: Boolean(manifestNumber),
    refetchOnWindowFocus: false,
  });

  return { data, isLoading: isLoading || isFetching, error };
};
